import { LocalStorageCapsule } from '@wix/data-capsule';

const CAPSULE_NAMESPACE = 'new-ai-chatbot-announcement';
const KEY = 'is_dismissed';

export const useLocalStorageAnnouncementData = () => {
  const capsule = LocalStorageCapsule({ namespace: CAPSULE_NAMESPACE });
  return {
    setIsDismissed: async (value: Boolean): Promise<void> => capsule.setItem(KEY, value),
    getIsDismissed: async (): Promise<boolean> => {
      try {
        return JSON.parse(await capsule.getItem(KEY));
      } catch {
        return false;
      }
    },
  };
};
